import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { consumeAccountDeletedFlag } from "../../lib/deleteAccount";
import FAQSection from "./FAQSection";
import FeaturesSection from "./FeaturesSection";
import FinalCTASection from "./FinalCTASection";
import HeroSection from "./HeroSection";
import LandingFooter from "./LandingFooter";
import LandingHeader from "./LandingHeader";
import PricingSection from "./PricingSection";

/* ═══════════════════════════════════════════════
   Main Landing Page
   ═══════════════════════════════════════════════ */

const LandingPage: React.FC = () => {
  const { signInWithGoogle, isLoading } = useAuth();
  const [showDeletedBanner] = useState(() => consumeAccountDeletedFlag());

  // Scopes the smooth-scroll CSS rule (src/index.css) to this page's "#features"
  // anchor link, so it doesn't animate scrolling in the rest of the app.
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("landing-page");
    return () => root.classList.remove("landing-page");
  }, []);

  return (
    <div className="min-h-screen bg-warm-bg-base overflow-x-clip">
      <LandingHeader onSignIn={signInWithGoogle} isLoading={isLoading} />
      {showDeletedBanner ? (
        <div
          role="status"
          className="fixed top-16 left-0 right-0 z-40 border-b border-warm-border bg-warm-bg-elevated"
        >
          <p className="max-w-6xl mx-auto px-6 py-3 text-sm text-warm-text-primary text-center">
            Your account has been deleted. All of your JuDI data has been
            removed.
          </p>
        </div>
      ) : null}
      <HeroSection onSignIn={signInWithGoogle} isLoading={isLoading} />
      <FeaturesSection />
      <PricingSection onSignIn={signInWithGoogle} isLoading={isLoading} />
      <FAQSection />
      <FinalCTASection onSignIn={signInWithGoogle} isLoading={isLoading} />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
